import { useRef } from 'react'
import { useSelect } from 'downshift'

export interface Option {
  value: string
  label: string
  color?: string
}

export function Dropdown({ value, options, onSelect, className, style, dropUp }: {
  value: string
  options: Option[]
  onSelect: (value: string, ctrlKey: boolean) => void
  className?: string
  style?: React.CSSProperties
  dropUp?: boolean
}) {
  const selected = options.find(o => o.value === value) ?? null

  const { isOpen, highlightedIndex, getToggleButtonProps, getMenuProps, getItemProps } = useSelect({
    items: options,
    selectedItem: selected,
    itemToString: o => o?.label ?? '',
    onSelectedItemChange: ({ selectedItem }) => {
      if (selectedItem) { onSelect(selectedItem.value, ctrlRef.current); ctrlRef.current = false }
    },
  })

  const ctrlRef = useRef(false)

  return (
    <div className={className} style={{ position: 'relative', display: 'inline-block', ...style }}>
      <button
        className="label-select"
        style={selected?.color ? { color: selected.color, fontWeight: 700 } : undefined}
        {...getToggleButtonProps()}
        onContextMenu={e => e.preventDefault()}
      >
        {selected?.label ?? value}
      </button>
      <ul
        {...getMenuProps()}
        className="dropdown-menu"
        style={{ display: isOpen ? undefined : 'none', ...(dropUp ? { bottom: '100%', top: 'auto' } : {}) }}
        onContextMenu={e => e.preventDefault()}
      >
        {isOpen && options.map((o, i) => (
          <li
            key={o.value}
            className={'dropdown-item' + (o.value === value ? ' selected' : '') + (i === highlightedIndex ? ' focused' : '')}
            style={o.color ? { color: o.color } : undefined}
            {...getItemProps({
              item: o,
              index: i,
              onMouseDown: (e: React.MouseEvent) => { ctrlRef.current = e.ctrlKey },
            })}
          >
            {o.label}
          </li>
        ))}
      </ul>
    </div>
  )
}
